export default "__VITE_ASSET__SNbv8yTS__"